import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Here we describe stepwise how to design a listening experiment. Such an experiment is usually created in order to check a hypothesis, which is based on an initial observeration. Each step requires decisions of the experiment designer.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 3,
      rowsSize: [1, 4, 2],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<b>Methods of data collection</b>",
                  formatter: "html",
                  scrollbars: false,
                },
              },
              styles: {
                fontSize: "18px",
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/23/principle/principle-6-content.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "hint",
                options: {
                  data:
                    "A <strong>between-subject</strong> design will require a <strong>higher number of participants</strong>, a within subject design, however, requires a thoroughly planned order of the conditions (e.g., counterbalanced) and <strong>fatigue or learning effects</strong> must be considered. An <strong>adequate number of participants</strong> for the experiment can be obtained by a <strong>power analysis.</strong>",
                  size: "large-thin",
                  color: "primary",
                  direction: "row",
                },
              },
              styles: {
                padding: "1% 0 4% 0",
                maxWidth: "70%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
